/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewWorkflowStepFunctionPublishedEventOnFailure } from '../models/new-workflow-step-function-published-event-on-failure';
import { WorkflowStepFunctionPublishedEventOnFailure } from '../models/workflow-step-function-published-event-on-failure';
import { WorkflowStepFunctionPublishedEventOnFailurePartial } from '../models/workflow-step-function-published-event-on-failure-partial';
import { WorkflowStepFunctionPublishedEventOnFailureWithRelations } from '../models/workflow-step-function-published-event-on-failure-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class WorkflowStepFunctionPublishedEventOnFailureControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation workflowStepFunctionPublishedEventOnFailureControllerCount
   */
  static readonly WorkflowStepFunctionPublishedEventOnFailureControllerCountPath = '/workflow-step-function-published-event-on-failures/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionPublishedEventOnFailureControllerService.WorkflowStepFunctionPublishedEventOnFailureControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation workflowStepFunctionPublishedEventOnFailureControllerFindById
   */
  static readonly WorkflowStepFunctionPublishedEventOnFailureControllerFindByIdPath = '/workflow-step-function-published-event-on-failures/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<WorkflowStepFunctionPublishedEventOnFailureWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionPublishedEventOnFailureControllerService.WorkflowStepFunctionPublishedEventOnFailureControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkflowStepFunctionPublishedEventOnFailureWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<WorkflowStepFunctionPublishedEventOnFailureWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<WorkflowStepFunctionPublishedEventOnFailureWithRelations>) => r.body as WorkflowStepFunctionPublishedEventOnFailureWithRelations)
    );
  }

  /**
   * Path part for operation workflowStepFunctionPublishedEventOnFailureControllerDeleteById
   */
  static readonly WorkflowStepFunctionPublishedEventOnFailureControllerDeleteByIdPath = '/workflow-step-function-published-event-on-failures/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionPublishedEventOnFailureControllerService.WorkflowStepFunctionPublishedEventOnFailureControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowStepFunctionPublishedEventOnFailureControllerUpdateById
   */
  static readonly WorkflowStepFunctionPublishedEventOnFailureControllerUpdateByIdPath = '/workflow-step-function-published-event-on-failures/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: WorkflowStepFunctionPublishedEventOnFailurePartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionPublishedEventOnFailureControllerService.WorkflowStepFunctionPublishedEventOnFailureControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: WorkflowStepFunctionPublishedEventOnFailurePartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowStepFunctionPublishedEventOnFailureControllerFind
   */
  static readonly WorkflowStepFunctionPublishedEventOnFailureControllerFindPath = '/workflow-step-function-published-event-on-failures';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<WorkflowStepFunctionPublishedEventOnFailureWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionPublishedEventOnFailureControllerService.WorkflowStepFunctionPublishedEventOnFailureControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkflowStepFunctionPublishedEventOnFailureWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<WorkflowStepFunctionPublishedEventOnFailureWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<WorkflowStepFunctionPublishedEventOnFailureWithRelations>>) => r.body as Array<WorkflowStepFunctionPublishedEventOnFailureWithRelations>)
    );
  }

  /**
   * Path part for operation workflowStepFunctionPublishedEventOnFailureControllerCreate
   */
  static readonly WorkflowStepFunctionPublishedEventOnFailureControllerCreatePath = '/workflow-step-function-published-event-on-failures';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewWorkflowStepFunctionPublishedEventOnFailure
  }): Observable<StrictHttpResponse<WorkflowStepFunctionPublishedEventOnFailure>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionPublishedEventOnFailureControllerService.WorkflowStepFunctionPublishedEventOnFailureControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkflowStepFunctionPublishedEventOnFailure>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewWorkflowStepFunctionPublishedEventOnFailure
  }): Observable<WorkflowStepFunctionPublishedEventOnFailure> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<WorkflowStepFunctionPublishedEventOnFailure>) => r.body as WorkflowStepFunctionPublishedEventOnFailure)
    );
  }

}
